
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { NavLink } from 'react-router-dom';


const ErrorPage = () => {
  return (
    <Wrapper>
      <div className="Error-container">

        <h2>Error 404</h2>
        
        <h3>Uh Oh! You're Lost</h3>
        <div className="error-section">
        <p className="error-para">The page you are finding doesn't exist. Click on the button to go to the HomePage. </p>
       
        <NavLink to="/">
        <Button>Home</Button>
        </NavLink>
        </div>
      </div>

      
    </Wrapper>
  )
};
const Wrapper=styled.section`

margin-top:10rem;
text-align:center;
display:block;
    .error-section{
        padding-top:2rem;

        .error para{
         padding-top:2rem;
        
          font-size:20px;
        }
}
`;


export default ErrorPage
